export enum HospitalizationCause {

    CONDITION_1 = 'Desnutrición aguda (SD3-/SD2-) e edema en ambos pies',
    CONDITION_2 = 'Edema generalizado',
    CONDITION_3 = 'Sin apetito e complicaciones',
    CONDITION_4 = 'Sin apetito e otra enfermedad',

}
